import Link from 'next/link'
import styled, { css } from 'styled-components'

type ProductVerticalCardProps = {
  isblackfriday?: string
  ishotsite?: string
  isfavorite?: string
  issearchandcategory?: string
}

export const ProductVerticalCard = styled(Link)<ProductVerticalCardProps>`
  display: flex;
  justify-content: center;
  width: auto;
  height: 100%;
  text-decoration: none !important;
  ${({ isblackfriday }) =>
    isblackfriday === 'true' &&
    css`
      background-color: '#fff';
      border-radius: 0.5rem;
    `}

  > div {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    background-color: #fff;

    @media (max-width: 480px) {
      padding-top: 0.875rem;
      padding-bottom: 0.875rem;
    }

    ${({ ishotsite, issearchandcategory }) =>
      (ishotsite === 'true' || issearchandcategory === 'true') &&
      css`
        @media (min-width: 768px) {
          min-width: 15.5rem !important;
        }
      `}

    ${({ isfavorite }) =>
      isfavorite === 'true' &&
      css`
        @media (min-width: 768px) {
          min-width: 14.5rem !important;
        }
      `}
  }

  // TODO after remove global css then remove this
  // conflicts with global css
  * {
    font-size: unset;
  }

  // TODO after remove ANTD ui then remove this
  // conflict with ANTD css
  p {
    margin: 0;
  }
`
